import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constants } from '../../constants';
import { SharedService } from '../../services/shared.service';
import { PlayList, VeNewsFeed } from '../../typings';

@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrl: './playlist.component.scss',
  standalone: false,
  animations: [
    trigger('fadePrevious', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateX(0%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.8) translateX(-100%)'
      })),
      transition('in => out', [
        animate('750ms')
      ]),
    ]),
    trigger('arriveCurrent', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateX(-100%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.5) translateX(100%)'
      })),
      transition('out => in', [
        animate('750ms')
      ]),
    ]),
    trigger('leaveNext1', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateX(0%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.5) translateX(-100%)'
      })),
      transition('in => out', [
        animate('750ms')
      ]),
    ]),
    trigger('leaveNext2', [
      state('in', style({
        opacity: 0.75, transform: 'translateX(0%)'
      })),
      state('out', style({
        opacity: 1, transform: 'translateX(-100%)'
      })),
      transition('in => out', [
        animate('750ms')
      ]),
    ]),
    trigger('leaveNext3', [
      state('in', style({
        opacity: 0.5, transform: 'translateX(0%)'
      })),
      state('out', style({
        opacity: 0.75, transform: 'translateX(-100%)'
      })),
      transition('in => out', [
        animate('750ms')
      ]),
    ]),
    trigger('leaveNext4', [
      state('in', style({
        opacity: 0.25, transform: 'translateX(0%)'
      })),
      state('out', style({
        opacity: 0.5, transform: 'translateX(-100%)'
      })),
      transition('in => out', [
        animate('750ms')
      ]),
    ]),
    trigger('leaveNext5', [
      state('in', style({
        opacity: 0.25, transform: 'translateX(-100%)'
      })),
      state('out', style({
        opacity: 0, transform: 'translateX(0%)'
      })),
      transition('out => in', [
        animate('750ms')
      ]),
    ]),
    trigger('fadeInOut', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateY(0%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.5) translateY(100%)'
      })),
      transition('in <=> out', [
        animate('500ms')
      ])
    ])
  ]
})
export class PlaylistComponent implements OnDestroy {
  public currentPlayList: PlayList;
  public animationStateOut = false;
  public nextNews5: VeNewsFeed;
  public animationPlaylistStateOut = false;

  private videoTimeoutId?: number;
  private changeValueTimeoutId?: number;
  private videoEndedSub: Subscription;

constructor(private sharedService: SharedService) {
  this.videoEndedSub = this.sharedService.videoEnded$.subscribe(
    video => {
      this.animationPlaylistStateOut = false;
  });
  }

  public setInitialValue(v: PlayList) {
    this.currentPlayList = v;
    this.handleVideo(5000);
    
  }

  public changeValue(newPlayList: PlayList) {
    this.animationStateOut = true;
    if(this.animationPlaylistStateOut) {
      this.animationPlaylistStateOut = false;
    }
    this.clearChangeValueTimeout();
    this.clearVideoTimeout();
    this.changeValueTimeoutId = window.setTimeout(() => {
      this.animationStateOut = false;
      this.currentPlayList = newPlayList;
      this.handleVideo(5000);
    }, 1000);

  
  }

  private handleVideo(timer:number)
  {
    if (this.isNewsWithVideo(this.currentPlayList)) {
      this.videoTimeoutId = window.setTimeout(() => {
        this.animationPlaylistStateOut = true;
      }, timer);
     
    }
  }

  public isNewsWithVideo(currentPlayList: PlayList) {
    if (currentPlayList?.currentNews?.videoUrl?.startsWith(Constants.BaseUrl.Youtube_URL) ||
      currentPlayList?.currentNews?.videoUrl?.startsWith(Constants.BaseUrl.Blob_DEV_URL) || 
      currentPlayList?.currentNews?.videoUrl?.startsWith(Constants.BaseUrl.Blob_UAT_URL) ||
      currentPlayList?.currentNews?.videoUrl?.startsWith(Constants.BaseUrl.Blob_PRE_URL) ||
      currentPlayList?.currentNews?.videoUrl?.startsWith(Constants.BaseUrl.Blob_PRD_URL)) {
      return true;
    }
    else {
      return false;
    }
  }

  chargeCanvas(news: VeNewsFeed, index: number) {
    const img = document.getElementById('image' + index) as HTMLImageElement;
    const canvas = document.getElementById('canvas' + index) as HTMLCanvasElement;
    const ctx = canvas?.getContext("2d");
    var hRatio = canvas.width / img.width;
    var vRatio = canvas.height / img.height;
    var ratio = Math.max(hRatio, vRatio);

    const centerShiftX = (canvas.width - img.width * ratio) / 2;
    const centerShiftY = (canvas.height - img.height * ratio) / 2;

    ctx?.clearRect(0, 0, canvas.width, canvas.height);
    ctx?.drawImage(img, 0, 0, img.width, img.height, centerShiftX, centerShiftY, img.width * ratio, img.height * ratio);
  }

  public clearVideoTimeout(): void {
    if (this.videoTimeoutId) {
      window.clearTimeout(this.videoTimeoutId);
      this.videoTimeoutId = undefined;
    }
  }

  public clearChangeValueTimeout(): void {
    if (this.changeValueTimeoutId) {
      window.clearTimeout(this.changeValueTimeoutId);
      this.changeValueTimeoutId = undefined;
    }
  }

  ngOnDestroy(): void {
    this.clearVideoTimeout();
    this.clearChangeValueTimeout();
    this.videoEndedSub?.unsubscribe();
  }
}
